import { render } from "./Tags.vue?vue&type=template&id=a6d94a64&scoped=true&ts=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=a6d94a64&lang=scss&scoped=true"
import "./Tags.vue?vue&type=style&index=1&id=a6d94a64&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d94a64"]])

export default __exports__